export enum Currency {
  US_DOLLAR = "USD", // Доллар США
  UZBEK_SOM = "UZS", // Узбекский сум
}
